import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
export const loadingSlice = createSlice({
    name: 'app/loading',
    initialState: {
        isLoading: false
    },
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        stopLoading(state) {
            state.isLoading = false;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(isPending, (state) => {
            state.isLoading = true;
        });
        builder.addMatcher(isFulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addMatcher(isRejected, (state) => {
            state.isLoading = false;
        });
    }
});
export const { startLoading, stopLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
